import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import ProfileMenu from "../ProfileSection/ProfileMenu";
import { Header } from "antd/es/layout/layout";
import LOGO from "../../assests/images/logo3.png";
import { Flex } from "antd";
import CoursesMenu from "../coursesMenu/CoursesMenu";
// import SearchBar from '../../UI/SearchBar';
import { UserOutlined, LogoutOutlined, BellOutlined } from "@ant-design/icons";
import { images } from "../../assests/imageExport/ImageExports";
import {
  HeartOutlined,
  MessageOutlined,
  HistoryOutlined,
  SettingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Input } from "antd";
import useGetApi from "../../services/useGetApi";
import { useAuth } from "../../user/context/AuthContext";
const { Search } = Input;

const AppHeader = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  // const [collapsed, setCollapsed] = useState(false);
  const { isAuthenticated } = useAuth();

  const handleClickDashboard = () => {
    navigate("/dashboard");
  };

  const [courseShow, setCourseShow] = useState(false);
  const [profileshow, setProfileShow] = useState(false);
  const [searchBarshow, setSearchbarShow] = useState(false);
  const [wishListShow, setWishListShow] = useState(false);
  const [notificationShow, setNotificationshow] = useState(false);
  const [isLoading, courseError, notifications, getData] = useGetApi(
    `notifications`,
    [],
    true
  );

  useEffect(() => {
    getData(`notifications`);
  }, []);

  const onSearch = (value, _e, info) => console.log(info?.source, value);

  // Handle when the mouse enters the "Courses" button
  const handleCoursesEnter = (title) => {
    if (title === "courses") {
      setCourseShow(true); // Show menu
    } else if (title === "user") {
      setProfileShow(true);
    } else if (title === "wishlist") {
      setWishListShow(true);
    } else if (title === "notification") {
      setNotificationshow(true);
    }
  };

  // Handle when the mouse enters the menu
  const handleMenuEnter = (title) => {
    if (title === "courses") {
      setCourseShow(true); // Keep menu visible when hovering over the menu
    } else if (title === "user") {
      setProfileShow(true);
    } else if (title === "wishlist") {
      setWishListShow(true);
    } else if (title === "notification") {
      setNotificationshow(true);
    }
  };

  // Handle when the mouse leaves the "Courses" button
  const handleCoursesLeave = (title) => {
    if (title === "courses") {
      // Hide the menu only if the mouse is not over the menu
      setCourseShow(false);
    } else if (title === "user") {
      setProfileShow(false);
    } else if (title === "wishlist") {
      setWishListShow(false);
    } else if (title === "notification") {
      setNotificationshow(false);
    }
  };

  // Handle when the mouse leaves the menu
  const handleMenuLeave = (title) => {
    if (title === "courses") {
      // Hide the menu when mouse leaves the menu
      setCourseShow(false);
    } else if (title === "user") {
      setProfileShow(false);
    } else if (title === "wishlist") {
      setWishListShow(false);
    } else if (title === "notification") {
      setNotificationshow(false);
    } else if (title === "notification") {
      setNotificationshow(false);
    }
  };

  return (
    <div className="navbar">
      {/* <Flex justify="space-between" style={{ flexWrap: "wrap" }}> */}
        {/* <div className="navbar_left">
          <img
            src={images.logo}
            className="navbar_logo"
            onClick={() => navigate("/")}
            alt="broken_image"
          />
          <button
            className="courses_btn"
            onMouseEnter={() => handleCoursesEnter("courses")}
            onMouseLeave={() => handleCoursesLeave("courses")}
            onClick={() => navigate("/courses")}
          >
            <MenuFoldOutlined /> Courses
          </button>
          {courseShow && (
            <div
              onMouseEnter={() => handleMenuEnter("courses")}
              onMouseLeave={() => handleMenuLeave("courses")}
            >
              <CoursesMenu />
            </div>
          )}
          {searchBarshow ? null : (
            <SearchOutlined onClick={() => setSearchbarShow((val) => !val)} />
          )}
          {searchBarshow && (
            <Search
              placeholder="input search text"
              onSearch={onSearch}
              style={{
                width: 200,
              }}
            />
          )}
        </div> */}
        <div>
          {isAuthenticated() ? (
            <div className="navbar_right">
              {/* <div className="navbar_right_icons">
                <span className="mt-5">
                  <Link to={"/user/my-courses"} className="link">
                    My course
                  </Link>
                </span>

                <div>
                  <BellOutlined
                    className="wishlist_icon"
                    onMouseEnter={() => handleCoursesEnter("notification")}
                    onMouseLeave={() => handleCoursesLeave("notification")}
                  />
                  {notificationShow && (
                    <div
                      className="wishList_div"
                      onMouseEnter={() => handleMenuEnter("notification")}
                      onMouseLeave={() => handleMenuLeave("notification")}
                    >
                      <div>
                        <div className="remove_all_div">
                          <p className="light_grey">Remove all</p>
                        </div>
                        {notifications.length > 0 &&
                          notifications.map((item, index) => (
                            <div>
                              <div
                                className="notifications_div_navbar"
                                key={item?.id}
                              >
                                <BellOutlined />
                                <div className="notifications">
                                  <span>{item?.description}</span>
                                </div>
                              </div>
                              <div className="horizontal_line"> </div>
                            </div>
                          ))}
                      </div>
                      <button className="mark_as_all_read_btn">
                        Mark all as read
                      </button>
                    </div>
                  )}
                </div>
              </div> */}
              <ProfileMenu />
            </div>
          ) : (
            <p>login</p>
            // <div className="navbar_right">
            //   <Link to={"/login"} className="link login_signup_link">
            //     <p>Login</p>
            //   </Link>
            //   <Link
            //     to={"https://adminpanel.taggeo.in/login"}
            //     className="link login_signup_link"
            //   >
            //     <p>Admin</p>
            //   </Link>
            // </div>
          )}
        </div>
      {/* </Flex> */}
    </div>
    // <Header className="header_main">
    //   <div className="header_section">
    //     <div className="header_left">
    //       <Button
    //         type="text"
    //         icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
    //         onClick={() => setCollapsed(!collapsed)}
    //         style={{
    //           fontSize: "16px",
    //           width: 64,
    //           height: 64,
    //         }}
    //       />
    //       <img
    //         alt="logo"
    //         width={200}
    //         src={LOGO}
    //         className="move-dashboard"
    //         onClick={handleClickDashboard}
    //       />

    //     </div>
    //     <div className="header_right">
    //       <ProfileMenu />
    //     </div>
    //   </div>
    // </Header>
  );
};

export default AppHeader;
